(function() {
    'use strict';

    angular
        .module('hotransferApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','GLOBAL_URL'];

    function stateConfig($stateProvider,GLOBAL_URL) {
        $stateProvider.state('viewAll', {
            url: '/hotransfer/:typeMenu',
            data: {
                pageTitle: 'Đề nghị điều phối VPC'
            },
            params: { paramSearch: {squash: true, value: null }},
            views: {
                'content@': {
                    templateUrl: GLOBAL_URL+'partial?uri=e-stock/hotransfer/template/hotransfer',
                    controller: 'HoTransferController',
                    controllerAs: 'transferCtr'
                }
            }
        })
        .state('viewAllLoad', {
			    url: '/hotransferSearch/:typeMenu/:paramSearch',
			    data: {
			        pageTitle: 'Đề nghị điều phối VPC'
			    },
			    params: { paramSearch: {squash: true, value: null }},
			    views: {
			        'content@': {
			            templateUrl: GLOBAL_URL+'partial?uri=e-stock/hotransfer/template/hotransfer',
			            controller: 'HoTransferController',
			            controllerAs: 'transferCtr'
			        }
			    }
        })
        .state('info', {
            url: '/hotransfer/:typeMenu/:typeProcess/:paramSearch/:stockTransferCode',
            data: {
                pageTitle: 'Tạo phiếu đề nghị điều phối VPC'
            },
            params: { stockTransferCode: {squash: true, value: null },paramSearch: {squash: true, value: null }},
            views : {
				'content@' : {
					templateUrl: GLOBAL_URL+'partial?uri=e-stock/hotransfer/template/hotransfer-info',
					controller: 'HoTransferInfoController',
					controllerAs:'transferInfoCtr'
				}
			}
        })
    }
})();
